import { getApiOrigin } from '@hungryroot/rest';

export const getCustomerAddress = () => {
  return new Promise((resolve, reject) => {
    let xhr = $.ajax({
      url: `${getApiOrigin()}/api/get_address/`,
      type: 'GET',
    });
    xhr.done((data) => {
      resolve(data);
    });
    xhr.fail((jqXHR, textStatus, errorThrown) => {
      reject(
        `Got ${textStatus} when trying to get customer address. Error: ${errorThrown}`
      );
    });
  });
};

export const validateAddress = (data) => {
  return new Promise((resolve, reject) => {
    let options = {
      type: 'POST',
      url: `${getApiOrigin()}/api/validate_address/`,
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify(data),
    };
    let xhr = $.ajax(options);
    xhr.done((newData) => {
      resolve(newData);
    });
    xhr.fail((jqXHR, textStatus, errorThrown) => {
      console.error(
        `validateAddress: Got ${textStatus} when trying to validate the address. Error: ${errorThrown}`
      );
      reject(jqXHR.responseJSON);
    });
  });
};

// Beside the address remement to pass the 'order_id' to data.
export const saveAddress = (data) => {
  return new Promise((resolve, reject) => {
    let options = {
      type: 'POST',
      url: `${getApiOrigin()}/api/save_address/`,
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify(data),
    };
    let xhr = $.ajax(options);
    xhr.done((newData) => {
      resolve(newData);
    });
    xhr.fail((jqXHR, textStatus, errorThrown) => {
      reject(
        `postAddressError: Got ${textStatus} when trying to save the address. Error: ${errorThrown}`
      );
      alert(
        `Something has gone wrong. Please refresh the page. If the problem persists please contact help@hungryroot.com`
      );
    });
  });
};

export const submitPromo = (orderId, promoCode) => {
  return new Promise((resolve, reject) => {
    let options = {
      type: 'POST',
      url: `${getApiOrigin()}/api/submit_promo/`,
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify({
        order_id: orderId,
        promo: promoCode,
      }),
    };
    let xhr = $.ajax(options);
    xhr.done((newData) => {
      resolve(newData);
    });
    xhr.fail((jqXHR, textStatus, errorThrown) => {
      reject(
        `submit promo code: Got ${textStatus} when trying to submit a promo code. Error: ${errorThrown}`
      );
      alert(
        `Something has gone wrong. Please refresh the page. If the problem persists please contact help@hungryroot.com`
      );
    });
  });
};

export const saveCard = (data) => {
  return new Promise((resolve, reject) => {
    let options = {
      type: 'POST',
      url: `${getApiOrigin()}/api/save_payment/`,
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify(data),
    };
    let xhr = $.ajax(options);
    xhr.done((newData) => {
      resolve(newData);
    });
    xhr.fail((jqXHR, textStatus, errorThrown) => {
      reject(
        `save card: Got ${textStatus} when trying to submit a card. Error: ${errorThrown}`
      );
      alert(
        `Something has gone wrong. Please refresh the page. If the problem persists please contact help@hungryroot.com`
      );
    });
  });
};
